import Vue from 'vue'
import Router from 'vue-router'
import wap from './wap'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/404',
      component: () => import('@/modules/404')
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/modules/index'], resolve)
    },
    {
      path: '/case',
      name: 'case',
      component: resolve => require(['@/modules/case'], resolve)
    },
    {
      path: '/developer',
      name: 'developer',
      component: resolve => require(['@/modules/developer'], resolve)
    },
    {
      path: '/merchants',
      name: 'merchants',
      component: resolve => require(['@/modules/merchants'], resolve)
    },
    {
      path: '/solutionProject',
      name: 'solutionProject',
      component: resolve => require(['@/modules/solution/project'], resolve)
    },
    {
      path: '/supplyChains',
      name: 'supplyChains',
      component: resolve => require(['@/modules/solution/supplyChains'], resolve)
    },
    {
      path: '/labour',
      name: 'labour',
      component: resolve => require(['@/modules/solution/labour'], resolve)
    },
    {
      path: '/finance',
      name: 'finance',
      component: resolve => require(['@/modules/solution/finance'], resolve)
    },
    {
      path: '/synergy',
      name: 'synergy',
      component: resolve => require(['@/modules/solution/synergy'], resolve)
    },
    {
      path: '/about',
      name: 'about',
      component: resolve => require(['@/modules/about'], resolve)
    },
    ...wap,
    { path: '/', redirect: '/index' },
    {
      path: '*',
      redirect: '/404',
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js